<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <OliveOilsForm :baseOliveOil="oliveOil" :baseOliveOilName="name" :loading="loading" @submit-requested="submitRequested"></OliveOilsForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import OliveOilsForm from './OliveOilsForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            oliveOil: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { OliveOilsForm },
    computed:
    {
        ...mapState('oliveOils', ['getOliveOilDetailsOutput']),
    },
    methods: {
        ...mapActions('oliveOils', ['getOliveOilDetails']),
        ...mapActions('oliveOils', ['putOliveOil']),
        submitRequested(oliveOil) {
            this.putOliveOil(oliveOil);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'OliveOilList' });
        }

        this.getOliveOilDetails(this.$route.query.id);
    },
    watch:
    {
        getOliveOilDetailsOutput: function(oliveOilOutput)
        {
            if(!oliveOilOutput && !oliveOilOutput.data)
            {
                router.push({ name: 'OliveOilList' });
            }
            else
            {
                this.oliveOil = oliveOilOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>